export default __webpack_public_path__ + "static/media/06_photo.be350f5a.jpeg";